import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useParams, useRouteMatch } from 'react-router';
import { useQuery } from '@apollo/client';
import GET_ORDER from 'api/queries/GET_ORDER';
import useBreadcrumbs from 'components/common/Breadcrumbs/useBreadcrumbs';
import Loader from 'components/common/Loader';
import ThemedRouteTabs, { RouteTab } from 'components/common/ThemedRouteTabs';
import { HeaderContext } from 'components/HeaderContext';
import './OrderDetails.scss';
import Scrollable from 'common/Scrollable';
import ProductionVolume from './ProductionVolume/ProductionVolume';
import SpecificationLeftSideBar from './Tabs/Specification/LeftSideBar/SpecificationLeftSideBar';
import OrderActions from './OrderListingMenu/OrderActions';
import { OrderSpecificationProvider } from './OrderSpecificationProvider';
import OrderVolume from './OrderVolume/OrderVolume';
import OrderModelSpecificationView from './Tabs/Specification/SpecificationsContent/OrderModelSpecificationView';
import OrderCorrection from './OrderCorrection/OrderCorrection';
export const adjustBreadcrumbs = (orderId, order) => {
    const { t } = useTranslation('orders');
    useBreadcrumbs({
        adjust: {
            orders: {
                // undefined, bo chcemy zmatchować nazwę każdej zakładki (i się jej pozbyć)
                matchBreadcrumbNames: ['orders', orderId, undefined],
                replaceBreadcrumbs: (originalBreadcrumbs) => {
                    if (!order)
                        return [];
                    const orderBreadcrumb = {
                        name: orderId,
                        label: `${order.orderId} (${t(`status.${order.status}`).toUpperCase()})`,
                        url: `/orders/${orderId}`,
                    };
                    return [originalBreadcrumbs[0], orderBreadcrumb];
                },
            },
        },
    }, [order]);
};
const OrderDetails = () => {
    var _a;
    const { t } = useTranslation('orders');
    const { orderId } = useParams();
    const { url } = useRouteMatch();
    const ordersUrl = url.split('/').slice(0, -1).join('/');
    const { data, loading } = useQuery(GET_ORDER, {
        variables: {
            id: orderId,
        },
    });
    const order = data === null || data === void 0 ? void 0 : data.node;
    adjustBreadcrumbs(orderId, order);
    const context = useContext(HeaderContext);
    useEffect(() => {
        context === null || context === void 0 ? void 0 : context.registerUrlComponent(url, order ? React.createElement(OrderActions, { order: order, ordersUrl: ordersUrl }) : React.createElement(React.Fragment, null));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order, url, ordersUrl]);
    const isOrderACorrection = ((_a = order === null || order === void 0 ? void 0 : order.correctedOrder) === null || _a === void 0 ? void 0 : _a.orderId) != null;
    const style = {
        display: 'grid',
        gridTemplateColumns: '400px 1fr',
    };
    return loading ? (React.createElement(Loader, { size: 40 })) : (React.createElement("div", { className: "OrderDetails" },
        React.createElement(ThemedRouteTabs, { className: "tabs" },
            React.createElement(RouteTab, { className: "tab", exact: true, to: `${url}/specifications` }, t('specifications')),
            React.createElement(RouteTab, { className: "tab", exact: true, to: `${url}/production-volume` }, t('production_volume')),
            React.createElement(RouteTab, { className: "tab", exact: true, to: `${url}/order-volume` }, t('order_volume')),
            React.createElement(RouteTab, { className: "tab", exact: true, to: `${url}/correction`, hidden: !isOrderACorrection }, t('correction'))),
        React.createElement(Scrollable, { className: "OrderDetailsContent" },
            React.createElement(Switch, null,
                React.createElement(OrderSpecificationProvider, { orderId: orderId },
                    React.createElement(Route, { exact: true, path: `${url}/specifications` },
                        React.createElement("div", { style: style },
                            React.createElement(SpecificationLeftSideBar, null),
                            React.createElement(OrderModelSpecificationView, null))),
                    React.createElement(Route, { exact: true, path: `${url}/production-volume` },
                        React.createElement(ProductionVolume, { order: order })),
                    React.createElement(Route, { exact: true, path: `${url}/order-volume` },
                        React.createElement(OrderVolume, { order: order })),
                    React.createElement(Route, { exact: true, path: `${url}/correction` },
                        React.createElement(OrderCorrection, { order: order })),
                    React.createElement(Redirect, { path: url, to: `${url}/specifications` }))))));
};
export default OrderDetails;
